import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  parseServiceOutput,
  requestConfig,
} from "../../globals";
import { getAuth } from "../../utils";
import { type Ensurance, ensurance } from "../schemas/ensurance";
import { ensuranceInput } from "../schemas/ensurance.input";

export const ensureAccountProps = z
  .object({ locale: z.string(), ensurance: ensuranceInput })
  .extend(requestConfig.shape);

export type EnsureAccountProps = z.infer<typeof ensureAccountProps>;

export const ensureAccount = async (
  args: EnsureAccountProps,
): Promise<Ensurance> => {
  const {
    brand,
    endpoint = env.ACCOUNT_SERVICE_URL,
    auth: Authorization = getAuth(),
    locale,
    ensurance: ensuranceInput,
    proxyAuthSecret,
  } = parseServiceInput(ensureAccountProps, args);

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization,
    ...(proxyAuthSecret ? { "X-NG-Proxy-Auth": proxyAuthSecret } : {}),
  });

  const response = await fetch(`${endpoint}/v3/auth/ensure-account`, {
    method: "POST",
    headers,
    body: JSON.stringify({ ...ensuranceInput, brand, locale }),
  });

  return parseServiceOutput(response, ensurance, {
    code: "MALFORMED_ENSURANCE",
    message: "Ensurance is malformed",
  });
};
